import { render, staticRenderFns } from "./IconFolderCross.vue?vue&type=template&id=54886b2e&"
import script from "./IconFolderCross.vue?vue&type=script&lang=js&"
export * from "./IconFolderCross.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports